import { theme } from './../../Assets/Styles/theme'

export const styles = {
  container: {
    display: 'flex',
    '& + *': {
      marginLeft: '5px',
    },
  },
  input: {
    display: 'flex',
    border: `1px solid ${theme.colors.iron}`,
    width: 92,
    background: 'white',
    padding: '0 35px 0 15px',
    boxSizing: 'content-box',
    lineHeight: '40px',
    color: '#546b81',
    position: 'relative',
    zIndex: 2,
    backgroundColor: 'transparent',

    '&:hover': {
      cursor: 'pointer',
    },
  },
  datePickerHeaderTitle: {
    color: theme.colors.regentGray,
    fontSize: 14,
    alignSelf: 'center',
    fontWeight: 700,
    marginRight: 10,
  },
  inputWrapper: {
    position: 'relative',
    backgroundColor: 'white',
  },
  icon: {
    position: 'absolute',
    width: 13,
    height: '100%',
    right: 15,
    top: 0,
    zIndex: 1,
    transform: ' rotate(90deg)',
    fill: theme.colors.secondary,
  },
}



// WEBPACK FOOTER //
// ./src/Components/DateRangeSelector/styles.js